exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "legend{display:block;width:auto;padding:0 5px;margin-bottom:0;font-size:inherit;line-height:inherit;border:auto;border-bottom:none;font-weight:bold;border:thin solid #868584;background:#fff}fieldset{margin-top:20px;border:2px groove threedface;padding:5px;background:#fff}", ""]);

// exports
